import * as PIXI from 'pixi.js';
import {Guide} from "./Guide";
import {Store} from "../models/Store";

// type t1 = { x: number; y: number };
// type t2 = { position: t1; time: number; };
// type t3 = { color: number; points: t2[]; };
// type t4 = { paths: t3[]; };

export class DrawingCanvas {
    private app?: PIXI.Application;
    private graphics?: PIXI.Graphics;
    private touchPanel?: PIXI.Graphics;
    // private data?: t4;
    private isDrawing = false;
    private color: number;
    private width: number;
    private intervalId?: number;

    constructor(color: number) {
        // this.data = Store.data;
        this.color = color;
        this.width = 1;
    }

    init(domElement: HTMLCanvasElement) {

        this.app = new PIXI.Application({
            view: domElement,
            backgroundColor: 0xffffff,
            width: 607,
            height: 607,
        });

        const faceGuideSprite = new Guide(Store.data.guide);
        faceGuideSprite.scale.set(.5);
        faceGuideSprite.position.set(607 / 2 - 930 / 4, 607 / 2 - 1026 / 4);
        this.app.stage.addChild(faceGuideSprite);

        this.touchPanel = new PIXI.Graphics();
        this.touchPanel.interactive = true;
        this.touchPanel
            .beginFill(0xff0000, 0.001)
            .drawRect(0, 0, this.app.renderer.width, this.app.renderer.height);
        this.app.stage.addChild(this.touchPanel);

        this.touchPanel.on('pointerdown', this.onPointerStart);
        this.touchPanel.on('pointermove', this.onPointerMove);
        this.touchPanel.on('pointerup', this.onPointerEnd);
        this.touchPanel.on('pointerupoutside', this.onPointerEnd);

        this.graphics = new PIXI.Graphics();
        this.app.stage.addChild(this.graphics);

        PIXI.Ticker.shared.add(this.onUpdate);

        // 一時的に描画シェア機能をオフにする
        // this.intervalId = window.setInterval(() => {
        //     Store.database_updatePaths();
        // }, 1000);
    }

    onPointerStart = (event: PIXI.InteractionEvent) => {
        Store.data.paths.push({color: this.color, width: this.width, points: []});
        this.registerPoint(event);
        this.isDrawing = true;
    };

    private registerPoint(event: PIXI.InteractionEvent) {
        const data = Store.data;

        const {x, y} = event.data.getLocalPosition(event.currentTarget);
        const path = data.paths[data.paths.length - 1];
        const points = path.points;

        // 前のポイントがある場合には、そのポイントから一定距離移動していないと保存しない
        const minDist = 4;
        if (points.length) {
            const lastPoint = points[points.length - 1].position;
            const dx = x - lastPoint.x;
            const dy = y - lastPoint.y;
            const d = Math.sqrt(dx * dx + dy * dy);
            if (d < minDist) return;
        }

        // ポイントを保存
        points.push({
            position: {x, y},
            time: Date.now(),
        });
    }

    onPointerMove = (event: PIXI.InteractionEvent) => {
        if (!this.isDrawing) return;
        this.registerPoint(event);
    };

    onPointerEnd = (event: PIXI.InteractionEvent) => {
        if (!this.isDrawing) return;
        this.registerPoint(event);
        this.isDrawing = false;

        // 1筆書き終わったタイミングでFirebaseにデータ追加
        const path = Store.data.paths[Store.data.paths.length - 1];
        Store.smileRegister.addPath(path);
    };

    onUpdate = () => {
        if (!this.graphics) return;

        const g = this.graphics;
        g.clear();

        for (let i of Store.data.paths) {

            const color = i.color;
            const width = i.width;
            const points = i.points;
            const p = points[0];
            g.lineStyle(width ? width * 6 : 2 * 6, color)
                .moveTo(p.position.x, p.position.y);

            for (let j = 1; j < points.length; j++) {
                const p = points[j];
                g.lineTo(p.position.x, p.position.y);
            }
        }
    };

    setColor(color: number) {
        this.color = color;
    }

    destroy() {
        this.touchPanel?.off('pointerdown', this.onPointerStart);
        this.touchPanel?.off('pointermove', this.onPointerMove);
        this.touchPanel?.off('pointerup', this.onPointerEnd);

        clearInterval(this.intervalId);

        this.app = undefined;
        this.graphics = undefined;
        this.touchPanel = undefined;
    }

    setWidth(width: number) {
        this.width = width;
    }
}
